import { render, staticRenderFns } from "./CardHeading.vue?vue&type=template&id=a5cec1d8&scoped=true&"
import script from "./CardHeading.vue?vue&type=script&lang=ts&"
export * from "./CardHeading.vue?vue&type=script&lang=ts&"
import style0 from "./CardHeading.vue?vue&type=style&index=0&id=a5cec1d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5cec1d8",
  null
  
)

export default component.exports